export const Z_INDEX = {
    default: 0,
    dropdown: 100,
    toast: 200,
    navigation: 300,
    modal: 400,
    tooltip: 500,
    loading: 9999,
}
